export default "__VITE_ASSET__mqeDTr70__"